<template>
  <div>
    <h1>SETTINGS</h1>
  </div>
</template>

<script>
export default {
  name: "ViewSettings",
};
</script>

<style>
</style>